export default "__VITE_PUBLIC_ASSET__90b9abc1__"